<template>
  <div>
    <div>
      <!-- Register v1 -->
      <b-card
        class="mb-0"
        title=""
      >
        <!-- form -->
        <validation-observer
          ref="updateLmsDriveForm"
          #default="{ invalid }"
        >
          <b-form @submit.prevent>
            <!-- meeting link-->
            <b-row>
              <b-col cols="12">
                <b-form-group
                  label="Batch"
                  label-for="batch"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Batch"
                    vid="batch"
                    rules="required"
                  >
                    <v-select
                      id="register-batch"
                      v-model="form.batch"
                      placeholder="Select the Batch"
                      :options="batch"
                      label="label"
                      :reduce="(option) => option.value"
                      :class="{ 'is-invalid': errors.length > 0 }"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <b-form-group
                  label="Intake"
                  label-for="intake"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Intake"
                    vid="intake"
                    rules="required"
                  >
                    <v-select
                      id="register-batch"
                      v-model="form.intake"
                      :options="intake"
                      label="label"
                      :reduce="(option) => option.value"
                      :class="{ 'is-invalid': errors.length > 0 }"
                      placeholder="Select the Intake"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- Drive Link -->
                <b-form-group
                  label="Drive Link"
                  label-for="drive_link"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Drive Link"
                    vid="drive_link"
                    rules="required|url"
                  >
                    <b-form-input
                      id="register-link"
                      v-model="form.drive_link"
                      placeholder="Enter Google Drive Link"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- Month -->
              <b-col cols="12">
                <b-form-group
                  label="Current Month"
                  label-for="month"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Month"
                    vid="month"
                    rules="required"
                  >
                    <v-select
                      id="select-month"
                      v-model="form.month"
                      :options="months"
                      label="label"
                      :reduce="(option) => option.value"
                      :class="{ 'is-invalid': errors.length > 0 }"
                      placeholder="Select Month"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <!-- status -->
              <b-col cols="12">
                <b-form-group
                  label="Status"
                  label-for="status"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Status"
                    vid="status"
                    rules="required"
                  >
                    <v-select
                      id="link_status"
                      v-model="form.link_status"
                      :options="options"
                      label="label"
                      :reduce="(option) => option.value"
                      :value="options.find((o) => o.value === form.link_status)"
                      placeholder="Select Status"
                    />

                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- Button -->
            <b-form-group>
              <b-form-input
                id="h-email"
                type="text"
                hidden
              />
            </b-form-group>

            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="invalid"
              @click="updateLmsDrive()"
            >
              Submit
            </b-button>
          </b-form>
        </validation-observer>
      </b-card>
      <!-- /Register v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'
import lmsDriveApi from '@/Api/Modules/lmsDriveLinks'
import {
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BForm,
  BButton,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BImg,
  BInputGroupAppend,
  BRow,
  BCol,
} from 'bootstrap-vue'
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from '@validations'

export default {
  name: 'Register',
  components: {
    vSelect,
    BCard,

    BCardTitle,
    BImg,
    BCardText,
    BForm,
    BButton,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BRow,
    BCol,

    // validations
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    LmsDrivedata: Object,
  },
  data() {
    return {
      form: {},
      batch: [
        { label: 'B03', value: 'B03' },
        { label: 'B04', value: 'B04' },
        { label: 'B05', value: 'B05' },
        { label: 'B06', value: 'B06' },
        { label: 'B07', value: 'B07' },
      ],

      intake: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
      ],
      months: [
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
      ],
      options: [
        { label: 'Active', value: 1 },
        { label: 'Expired', value: 0 },
      ],

      // validation rules
      required,
      email,
      confirmed,
      url,
      between,
      alpha,
      integer,
      password,
      min,
      digits,
      alphaDash,
      length,
    }
  },
  created() {
    this.initializeData()
  },
  methods: {
    // initialize data
    initializeData() {
      this.form = { ...this.LmsDrivedata }
    },
    // update meeting
    async updateLmsDrive() {
      // Validate form first
      const isValid = await this.$refs.updateLmsDriveForm.validate()
      if (!isValid) return

      // Show loading
      await this.$vs.loading({ scale: 0.8 })

      try {
        console.log('Form data:', this.form)
        console.log('Drive ID:', this.LmsDrivedata?.id)

        if (!this.LmsDrivedata?.id) {
          console.error('Drive ID is missing!')
          return
        }

        // Prepare payload
        const payload = {
          batch: String(this.form.batch).trim(),
          intake: String(this.form.intake).trim(),
          drive_link: String(this.form.drive_link).trim(),
          month: Number(this.form.month), // ensure number
          link_status: Number(this.form.link_status), // 0 or 1
        }

        console.log('Payload sent to API:', payload)

        // Call API
        await lmsDriveApi.updateDriveLink(payload, this.LmsDrivedata.id)

        this.$emit('updated') // parent will refresh table
        this.$emit('close') // parent will set show=false

        // Optionally reset form or close modal
        // this.$refs.updateLmsDriveForm.reset();
      } catch (error) {
        console.error('API Error:', error)
      } finally {
        this.$vs.loading.close()
      }
    },
  },
}
</script>
